// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"bw8","PDFToolbar":"bw9","icon":"bw-","active":"bw_","withSpacer":"bxa","roundedUp":"bxb","withBadge":"bxc"};